import { Component } from 'vue-property-decorator'

import CaseList from '@/modules/Case/scripts/cases-list'

@Component({})
export default class CaseListFromDashboard extends CaseList {
  async mounted () {
    this.onResize()
    await this.clearPage()
    this.getList()
  }
}
